import { useEffect, useRef, useState } from 'react';
import type { StemLevels } from '../types';

export function useLevelsState(status: 'idle' | 'loading' | 'playing' | 'paused', meters: { getLevels: () => Record<string, StemLevels> }) {
  const [levels, setLevels] = useState<Record<string, StemLevels>>({});
  const lastLevelsRef = useRef<Record<string, StemLevels>>({});

  useEffect(() => {
    let raf: number | null = null;
    let last = 0;
    const tick = (ts: number) => {
      if (status === 'playing') {
        if (ts - last >= 33) {
          last = ts;
          const lv = meters.getLevels() as Record<string, StemLevels>;
          setLevels(lv);
          lastLevelsRef.current = lv;
        }
        raf = requestAnimationFrame(tick);
      }
    };
    if (status === 'playing') raf = requestAnimationFrame(tick);
    return () => { if (raf) cancelAnimationFrame(raf!); };
  }, [status, meters]);

  return { levels, setLevels, lastLevelsRef };
}
